import AuthService from './authService.js';
import { addClientInvoiceAutomationCounts } from '../Helpers/invoiceAutomationClientHelper';

// The automatic invoicing of a third-party project. A failure comes back as a resolved { error } object.
export default class InvoiceAutomationService {
  static GetInvoiceAutomation(projectId) {
    const url = `/api/TpProject/GetInvoiceAutomation/${projectId}?clearCache=true`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static UpsertInvoiceAutomation(setup) {
    const url = 'api/TpProject/UpsertInvoiceAutomation/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(setup));
  }

  static SetInvoiceAutomationActive(projectId, isActive) {
    const url = 'api/TpProject/SetInvoiceAutomationActive/';
    const activation = { ProjectId: projectId, IsActive: isActive };
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(activation));
  }

  // runChoices: what a person ticked in Run Now ({ monthsToRemake, outOfScopeTypesToBringIn }, see getRunChoices).
  static RunInvoiceAutomation(projectId, runChoices) {
    const url = 'api/TpProject/RunInvoiceAutomation/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, JSON.stringify(createRunNow(projectId, runChoices)));
  }

  // What the run would do with the same choices; nothing is written.
  static GetInvoiceAutomationRunPreview(projectId, runChoices) {
    const url = 'api/TpProject/GetInvoiceAutomationRunPreview/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, JSON.stringify(createRunNow(projectId, runChoices)));
  }

  static GetInvoiceAutomationRuns(projectId) {
    const url = `/api/TpProject/GetInvoiceAutomationRuns/${projectId}?clearCache=true`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static GetInvoiceAutomationRunDetail(runId) {
    const url = `/api/TpProject/GetInvoiceAutomationRunDetail/${runId}?clearCache=true`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static GetInvoiceAutomationExcludedJobs(projectId) {
    const url = `/api/TpProject/GetInvoiceAutomationExcludedJobs/${projectId}?clearCache=true`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static GetInvoiceAutomationClientStatuses(clientIds) {
    const url = 'api/TpProject/GetInvoiceAutomationClientStatuses/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, JSON.stringify(clientIds));
  }

  // A page of the Clients list with the automatic invoicing counts of its clients, from one call for the whole page.
  // The page comes back as it was when that call fails or is refused, so the list still shows.
  static AddClientStatuses(clientPage) {
    const clients = clientPage?.data ?? [];
    if (clients.length === 0) {
      return Promise.resolve(clientPage);
    }

    const clientIds = clients.map((client) => client.clientId);
    return InvoiceAutomationService.GetInvoiceAutomationClientStatuses(clientIds)
      .then((clientStatuses) => {
        if (!Array.isArray(clientStatuses)) {
          return clientPage;
        }
        return { ...clientPage, data: addClientInvoiceAutomationCounts(clients, clientStatuses) };
      })
      .catch(() => clientPage);
  }
}

// The body Run Now and its preview send: the project, and what to bring into the run.
function createRunNow(projectId, runChoices) {
  return {
    ProjectId: projectId,
    MonthsToRemake: runChoices.monthsToRemake,
    OutOfScopeTypesToBringIn: runChoices.outOfScopeTypesToBringIn,
  };
}
